import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUsuarios } from '../models/usuarios';
@Injectable({
  providedIn: 'root'
})
export class usuariosComercialService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.SUrlgApi + 'UsuariosComercial';
  }

  getListadoUsuariosComercial(): Observable<any[]> {
    return this.http
      .get<any[]>(this.apiUrl+'/GetUsuariosComercial')
      .pipe(retry(1), catchError(this.handleError));
  }
  insertDatosClient(data:any):Observable<any>{
    return this.http.post<any>(this.apiUrl+'/insertDatosClient',data).pipe(retry(1), catchError(this.handleError));
  }
  getDatosClient(id_cte_prospecto:number):Observable<any>{
    let params={
        id_cteprospecto:id_cte_prospecto
    }
    return this.http.get<any>(this.apiUrl+'/GetDatosClient',{params}).pipe(retry(1), catchError(this.handleError));
  }
  getUsuarioComercial(cod_usuario:string):Observable<any>{
    let params={
        cod_usuario:cod_usuario,
      }
    return this.http.get<any>(this.apiUrl+'/GetUsuarioComercial',{params}).pipe(retry(1), catchError(this.handleError));
  }

  public PostUsuarioComercial(data:any):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    return this.http.post<any>(this.apiUrl + '/InsertUsuarioComercial',data,{'headers':headers});
   }

  public editUsuarioComercial(data: any ):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/EditUsuarioComercial/'+body,{'headers':headers});
   }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
